import { render } from "./UserShow.vue?vue&type=template&id=63bc4856&scoped=true"
import script from "./UserShow.vue?vue&type=script&lang=js"
export * from "./UserShow.vue?vue&type=script&lang=js"

import "./UserShow.vue?vue&type=style&index=0&id=63bc4856&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bc4856"]])

export default __exports__